module.exports = __webpack_public_path__ + "static/media/icons-dashboard-feedback.ae7c2a42.svg";